// Wishlist code

// wishlist.js
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.wishlist-button');

  // Load wishlist from localStorage or initialize
  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  // Update buttons for already added products
  buttons.forEach(btn => {
    const product = JSON.parse(btn.dataset.product);
    if (wishlist.includes(product.id)) {
      btn.textContent = '❤️ Added';
      btn.disabled = true;
    }
  });

  // Handle click
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const product = JSON.parse(btn.dataset.product);

      if (!wishlist.includes(product.id)) {
        wishlist.push(product.id);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        btn.textContent = '❤️ Added';
        btn.disabled = true;
      }
    });
  });
});
